<div class="flex gap-32 min-width-zero">
	<app-employee-checkin class="flex-fill min-width-zero"></app-employee-checkin>
	@if (!isArriveLeaveTerminal) {
		<app-terminal-select class="flex-fill"></app-terminal-select>
	}
	@if (!isArriveLeaveTerminal) {
		<app-terminal-station-select></app-terminal-station-select>
	}
	@if (!isArriveLeaveTerminal) {
		<app-terminal-menu (showNonReadyChange)="onShowNonReadyChange($event)"></app-terminal-menu>
	}
</div>

@if (dialogMessage) {
	<div class="dialogMessage" [ngClass]="dialogIsError ? 'error' : 'success'">
		{{ dialogMessage }}
	</div>
}

<app-task-select [class.show]="employeeService.currentEmployee"></app-task-select>

@if (terminalService.terminal && !isArriveLeaveTerminal) {
	<app-production-data-view [showNonReady]="showNonReady" />
}
